import { Overlay, Content, Close } from '@radix-ui/react-dialog'
import styled from 'styled-components'

export const StyledDialogOverlay = styled(Overlay)`
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  inset: 0;
  z-index: 901;
`

export const StyledDialogContent = styled(Content)<{desktopWidth?:string, mobileMaxWidth?:string}>`
  background-color: white;
  border-radius: 8px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 24px;
  display: flex;
  flex-direction: column;
  z-index: 10000;
  max-height: calc(100vh - 96px);
  max-width: calc(100vw - 48px);
  overflow: auto;
  box-sizing: border-box;
  width: ${({ desktopWidth }) => desktopWidth || 'unset'};

  ${props => props.theme.mediaQuery.down('tablet-landscape')} {
    width: 100%;
    padding: 24px;
    max-width: ${({ mobileMaxWidth }) => mobileMaxWidth || 'calc(100vw - 48px)'};
  }

  ${props => props.theme.mediaQuery.down('mobile-portrait')} {
    width: 100% !important;
  }
`

export const StyledDialogDeleteAccountContent = styled(Content)`
@media (max-width: 425px) {
  padding: 0px;
  width: 92%;
  overflow: scroll;
  max-height: 98%;
  scrollbar-width: none; 
  -ms-overflow-style: none;
  ::-webkit-scrollbar {
    display: none;
  }
}  

  background-color: white;
  border-radius: 8px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 0px;
  display: flex;
  flex-direction: column;
  z-index: 1000;
  overflow: auto;
  width:100%;
  max-height: calc(100vh - 64px);
  overflow-y: auto;
  max-height: calc(100vh - 64px);
  max-width: 700px;
  `

export const StyledDialogCloseButton = styled(Close)`
  border: none;
  padding: 0;
  margin: 0;
  background: transparent;
  height: 32px;
  width: 32px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: end;
`

export const StyledDialogHeader = styled('header')`
  display: flex;
  padding: 0;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
  position: sticky;
  top: 0;
`

export const StyledH3 = styled.h3`
  color: #3E3E47;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 165%;
  margin: 0;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
`
